import React from 'react';
import classNames from 'classnames';

import css from './IconCheckCircle.module.css';

/**
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element}
 */
const IconCheckCircle = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.3334 8.50005C17.3334 13.1024 13.6025 16.8334 9.00008 16.8334C4.39771 16.8334 0.666748 13.1024 0.666748 8.50005C0.666748 3.89768 4.39771 0.166718 9.00008 0.166718C13.6025 0.166718 17.3334 3.89768 17.3334 8.50005ZM12.3587 5.97478C12.6028 6.21885 12.6028 6.61458 12.3587 6.85866L8.19202 11.0253C7.94795 11.2694 7.55222 11.2694 7.30814 11.0253L5.64147 9.35866C5.3974 9.11458 5.3974 8.71885 5.64147 8.47478C5.88555 8.2307 6.28128 8.2307 6.52536 8.47478L7.75008 9.6995L9.61244 7.83714L11.4748 5.97478C11.7189 5.7307 12.1146 5.7307 12.3587 5.97478Z"
        fill="#297DDC"
      />
    </svg>
  );
};

export default IconCheckCircle;
